<template>
    <div>
        <div>
                <b-col>
                    <audit-log-table title="Logs" />
                </b-col>
        </div>
    </div>
</template>
<script>
import AuditLogTable from './AuditLogTable'
import permissionsMixins from '@/mixins/permissionsMixins'


export default {
    name: 'auditLogs',
    components: {
        AuditLogTable,
    },mixins: [permissionsMixins],

    data: () => {
        return {}
    },

    methods: {},
}
</script>
<style></style>
